import React, { useEffect, useRef } from 'react';
import $i18n from 'panda-i18n';
import { useSetState } from 'ahooks';
import { useHistory } from 'ice';
import { INBOUND_BOARD_DATA, RED_DATA, GREY_DATA } from '@/const';
import { getWarehouseCode, getLabelValue } from '@/utils';
import { getAllOrderQty, inTips } from './index.services';
import { Box, Loading } from '@fpxfd/next';
import FpxBarChart from '@/components/FpxBarChart';

import { ListProps, Props, StateProps } from './index.interface';

const InboundBoard = ({ time, title, dark, items = [], hz = 10000, reqDatas = undefined, locationState }: Props) => {
  const history = useHistory();
  const [state, setState] = useSetState<StateProps>({
    inboundList: [],
    loading: false,
    totalOrder: 0,
  });

  const inboundRef: React.MutableRefObject<ListProps[]> = useRef([]);
  inboundRef.current = state.inboundList;
  const loadRef: React.MutableRefObject<boolean> = useRef(false);
  loadRef.current = state.loading;

  const initDatas = () => {
    let d1: ListProps[] = [];
    !inboundRef.current?.length && setState({ loading: true });

    const reqData = {
      ...reqDatas,
      warehouseCode: getWarehouseCode(),
    };

    // 获取当日总单量
    getAllOrderQty(reqData).then((res) => {
      if (res === state.totalOrder) return;
      setState({
        totalOrder: res,
      });
    });

    inTips(reqData)
      .then((inRes = []) => {
        const list = items?.length ? items : INBOUND_BOARD_DATA;
        d1 = list?.map((e) => {
          const item = { ...getLabelValue(inRes, e?.value, { value: 'link' }) };
          // const item = { ...getLabelValue(inRes, e?.value, { value: 'name' }) };
          const orderNum = item?.orderNum || 0;
          const pcsNum = item?.pcsNum || 0;
          const data = {
            ...e,
            qty: e?.value === 'FE' ? orderNum : pcsNum,
            IC: orderNum,
            PCS: pcsNum,
          };
          if (data.state) {
            data.state = {
              ...data.state,
              ...locationState,
              time,
            };
          }
          return data;
        });
      })
      .finally(() => {
        if (JSON.stringify(d1) !== JSON.stringify(inboundRef.current)) {
          setState({
            inboundList: d1,
            loading: false,
          });
        }
      });
  };

  useEffect(() => {
    console.log(time, reqDatas);

    initDatas();
  }, [time, reqDatas]);

  useEffect(() => {
    const timer = setInterval(() => {
      initDatas();
    }, hz);
    return () => {
      clearInterval(timer);
    };
  }, [time]);

  const onClickFn = (event) => {
    if (event?.session && Object.keys(event?.session)?.length) {
      const d = event?.session;
      Object.keys(d)?.forEach((e) => {
        window.sessionStorage.setItem(e, JSON.stringify(d[e]));
      });
    }
    if (event?.blank) {
      window.open(event?.src);
    } else if (event?.src) {
      history.push({ pathname: event?.src, state: event?.state });
    }
  };

  return (
    <Loading visible={loadRef.current}>
      <FpxBarChart
        data={inboundRef.current}
        // title={title || $i18n.get({ id: 'StorageKanban.four_px', dm: '入库看板' })}
        title={
          title || (
            <Box direction="row" justify="space-between">
              <span>{$i18n.get({ id: 'StorageKanban.four_px', dm: '入库看板' })}</span>
              <span>{`${$i18n.get({ id: 'TotalQuantity.four_px', dm: '总单量' })}： ${state.totalOrder}`}</span>
            </Box>
          )
        }
        xField={'module'}
        yField={'qty'}
        color={(d) => {
          if (RED_DATA.includes(d.module)) return '#F98767';
          else if (GREY_DATA.includes(d.module)) return '#DEE1E4';
          return '#27D5B8';
        }}
        tooltip={{
          fields: ['IC', 'PCS'],
        }}
        events={{
          onBarClick: onClickFn,
          onPlotClick: onClickFn,
          onAxisXClick: onClickFn,
        }}
        dark={dark}
      />
    </Loading>
  );
};

export default InboundBoard;
